var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"view-footer"},[_vm._v(" 2008-"+_vm._s((new Date()).getFullYear())+" © All rights reserved ")])}
var staticRenderFns = []

export { render, staticRenderFns }